import { BaseModel } from '@shared/models/base.model'
import { Team } from '@shared/models/team.model'

export class History extends BaseModel {
  id: string
  createdByName: string
  payload: string
  createdAt: string
}

export class TeamHistory extends BaseModel {
  dateFrom: string
  dateTo: string | null
  entityId: number
  team: Team
  type: string
}
